import { AppUtils } from '../../utils/index';
import { PhoneModel } from "./Phone";
import { MembershipPersonalDataModel } from "./MembershipPersonalData";

/**
 * Model for partner on membership form.
 */
export class PartnerViewModel {

	private mitgliedsnummer: string;
	private personalData: MembershipPersonalDataModel;

	constructor() {
		this.PersonalData = new MembershipPersonalDataModel();
	}

	get Mitgliedsnummer(): string {
		return this.mitgliedsnummer;
	}

	set Mitgliedsnummer(value: string) {
		this.mitgliedsnummer = value;
	}

	get PersonalData(): MembershipPersonalDataModel {
		return this.personalData;
	}

	set PersonalData(value: MembershipPersonalDataModel) {
		this.personalData = value;
	}

	get Telefon(): PhoneModel {
		if (this.PersonalData.TelefonVorwahl !== undefined && this.PersonalData.TelefonNummer !== undefined) {
			return new PhoneModel(this.PersonalData.TelefonVorwahl, this.PersonalData.TelefonNummer);
		}
		return undefined;
	}

	public toString(): string {
		try {
			return JSON.stringify(this);
		} catch (e) {
			return Object.toString.apply(this);
		}
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	static createFromObject(dataObject: { [key: string]: any }): PartnerViewModel {
		return AppUtils.Helper.createFromMap(dataObject, PartnerViewModel, (key, value) => {
			if (key.toLowerCase() === 'personaldata') {
				return MembershipPersonalDataModel.createFromObject(value);
			} else {
				return value;
			}
		});
	}
}












